import styled from '@emotion/styled';
import { Spacer, Text } from '@koalafi/component-library';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

type ManualEntryLinkProps = {
  error: boolean;
  secondaryButtonAction: () => void;
};

const ManualLink = styled.a`
  font-size: 18px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  color: #4361ee;
  text-decoration: none !important;
  cursor: pointer;

  &:hover {
    text-decoration: none !important;
  }
`;

const ManualEntryLink: React.FC<ManualEntryLinkProps> = ({ error, secondaryButtonAction }) => {
  const { t } = useTranslation();
  const secondaryButtonClasses =
    'text-accents-primary hover:bg-surface-secondary-container disabled:bg-transparent disabled:text-on-disabled disabled:opacity-60 p-[1rem 0]';
  const buttonBorder = 'w-full p-sm border-2 disabled:border-on-disabled border-accents-primary';
  const buttonTextClass = 'font-[Inter-SemiBold] text-[1rem] justify-center items-center cursor-pointer';
  const combinedStyles = `${secondaryButtonClasses} ${buttonBorder} ${buttonTextClass}`;
  const manualEntryLinkText = t(($) => $.pagePaymentSelection.manualEntry);
  const manualLinkElement = (
    <ManualLink onClick={secondaryButtonAction} data-testid="payment-selection-manual">
      {manualEntryLinkText}
    </ManualLink>
  );

  return (
    <div>
      {error ? (
        <>
          <Spacer size="sm" />
          <Text size="md" alignText="left" weight="light">
            <Trans i18nKey={($) => $.pagePaymentSelection.manualEntryWhenError} components={{ ManualLink: manualLinkElement }} />
          </Text>
        </>
      ) : (
        <>
          <Spacer size="md" />
          <Text size="md" alignText="center" weight="medium">
            <ManualLink onClick={secondaryButtonAction} data-testid="payment-selection-manual">
              {t(($) => $.pagePaymentSelection.manualEntry)}
            </ManualLink>
          </Text>
        </>
      )}
    </div>
  );
};

export default ManualEntryLink;
